import CommonService from "./common.service";
import superAdminApi from "./superAdminApi";

const ME = "/me";
const SUPPORT = "/support";
const MANAGER = "/support-manager";
const SUPER = "/super-admin";
const PUBLIC = "/public/platform";

export const feedbackExtractMessage = (err, fallback = "Request failed") =>
  err?.response?.data?.message || err?.response?.data?.error || err?.message || fallback;

export const createPlatformFeedback = async (formData) => {
  const res = await CommonService.post(`${PUBLIC}/feedback`, formData, { silent: true });
  return res?.data ?? null;
};

export const fetchMyFeedbackList = async (params = {}) => {
  const res = await CommonService.get(`${ME}/feedback`, params, { silent: true });
  return res?.data ?? { items: [], total: 0 };
};

export const fetchMyFeedbackStats = async () => {
  const res = await CommonService.get(`${ME}/feedback/stats`, {}, { silent: true });
  return res?.data ?? { total: 0, inProgress: 0, resolved: 0, closed: 0 };
};

export const fetchMyFeedbackById = async (id) => {
  const res = await CommonService.get(`${ME}/feedback/${id}`, {}, { silent: true });
  return res?.data ?? null;
};

export const fetchSupportAssignedFeedback = async (params = {}) => {
  const res = await CommonService.get(`${SUPPORT}/feedback`, params, { silent: true });
  return res?.data ?? { items: [], total: 0 };
};

export const fetchSupportFeedbackStats = async () => {
  const res = await CommonService.get(`${SUPPORT}/feedback/stats`, {}, { silent: true });
  return res?.data ?? { total: 0, inProgress: 0, resolved: 0, closed: 0 };
};

export const fetchSupportFeedbackById = async (id) => {
  const res = await CommonService.get(`${SUPPORT}/feedback/${id}`, {}, { silent: true });
  return res?.data ?? null;
};

export const updateSupportFeedbackStatus = async (id, payload) => {
  const res = await CommonService.patch(`${SUPPORT}/feedback/${id}/status`, payload, { silent: true });
  return res?.data ?? null;
};

export const postSupportFeedbackMessage = async (id, { message, isInternal, attachment }) => {
  const form = new FormData();
  form.append("message", message || "");
  form.append("isInternal", isInternal ? "true" : "false");
  if (attachment) form.append("attachment", attachment);
  const res = await CommonService.post(`${SUPPORT}/feedback/${id}/messages`, form, { silent: true });
  return res?.data ?? null;
};

export const postManagerFeedbackNote = async (id, { message, attachment }) => {
  const form = new FormData();
  form.append("message", message || "");
  if (attachment) form.append("attachment", attachment);
  const res = await CommonService.post(
    `${MANAGER}/feedback/${id}/internal-notes`,
    form,
    { silent: true },
  );
  return res?.data ?? null;
};

export const fetchManagerFeedback = async (params = {}) => {
  const res = await CommonService.get(`${MANAGER}/feedback`, params, { silent: true });
  return res?.data ?? { items: [], total: 0 };
};

export const fetchManagerFeedbackById = async (id) => {
  const res = await CommonService.get(`${MANAGER}/feedback/${id}`, {}, { silent: true });
  return res?.data ?? null;
};

export const fetchManagerFeedbackAssignees = async () => {
  const res = await CommonService.get(`${MANAGER}/feedback/assignees`, {}, { silent: true });
  return res?.data?.items ?? [];
};

export const assignManagerFeedback = async (id, payload) => {
  const res = await CommonService.post(`${MANAGER}/feedback/${id}/assign`, payload, { silent: true });
  return res?.data?.feedback ?? null;
};

export const updateManagerFeedbackStatus = async (id, payload) => {
  const res = await CommonService.patch(`${MANAGER}/feedback/${id}/status`, payload, { silent: true });
  return res?.data ?? null;
};

export const fetchSuperAdminFeedback = async (params = {}) => {
  const res = await superAdminApi.get(`${SUPER}/feedback`, { params });
  return res.data?.data ?? { items: [], total: 0, page: 1, pageSize: 20 };
};

export const fetchSuperAdminFeedbackById = async (id) => {
  const res = await superAdminApi.get(`${SUPER}/feedback/${id}`);
  return res.data?.data ?? null;
};

export const FEEDBACK_STATUS_OPTIONS = [
  { value: "", label: "All Statuses" },
  { value: "new", label: "New" },
  { value: "under_review", label: "Under Review" },
  { value: "assigned", label: "Assigned" },
  { value: "in_progress", label: "In Progress" },
  { value: "waiting_user", label: "Waiting for User" },
  { value: "resolved", label: "Resolved" },
  { value: "closed", label: "Closed" },
];

export const FEEDBACK_TYPE_OPTIONS = [
  { value: "", label: "All Types" },
  { value: "Suggestion", label: "Suggestion" },
  { value: "Compliment", label: "Compliment" },
  { value: "Complaint", label: "Complaint" },
  { value: "Feature Request", label: "Feature Request" },
  { value: "Bug Report", label: "Bug Report" },
];

export const FEEDBACK_ASSIGNMENT_OPTIONS = [
  { value: "", label: "All Assignment" },
  { value: "unassigned", label: "Unassigned" },
  { value: "assigned", label: "Assigned" },
];
